<template>
  <div id="orderResultpage">
    <div align="center" style="margin-top: 48px" class="orderDiv">
      <div>
        <img
          src="static/qlbank/img_order_result.png"
          width="96px"
          height="72px"
        />
      </div>
      <div style="margin-top: 8px">
        <label style="font-size: 30px">上传图片正在审核中</label>
      </div>
      <div style="margin-top: 8px">
        <label>我们将在24小时内完成审核</label>
      </div>
      <div style="margin-top: 8px">
        <label>此期间请不要申请新的卡片</label>
      </div>
      <div style="margin-top: 8px">
        <label>否则将有可能导致此次申请开卡失败</label>
      </div>
      <div class="issue" @click="openIssue">>>发票开具入口</div>
    </div>
  </div>
</template>

<script scoped>
export default {
  name: "OrderResult_ql",
  data() {
    return {
      orderNo: "",
    };
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    console.log("to", to);
    console.log("from", from);
    next();
  },
  mounted: function () {
    this.orderNo = this.$route.params.orderNo;
    console.log("orderNo:" + this.orderNo);
  },
  methods: {
    //开具发票
    openIssue() {
      this.$router.replace({
        name: "Invoicesq_ql",
        params: {
          data: { orderNo: this.orderNo },
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
#orderResultpage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .orderDiv {
    position: relative;
    .issue {
      position: fixed;
      bottom: 20px;
      right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/qilubank/OrderResult_ql.vue